import { StateType } from '../index';
import { BaseTutorialStore } from './ConsultantTutorialReducer';
import { ConsultantTutorialStep } from '../../shared/api/api';

export const consultantTutorialSelector = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  if (!tutorialStore) return {} as BaseTutorialStore;

  return {
    isTutorialExpired: tutorialStore.isTutorialExpired,
    isTutorialModeActive: tutorialStore.isTutorialModeActive,
    currentlyViewedStep: tutorialStore.currentlyViewedStep,
    maxUnlockedTutorialStep: tutorialStore.maxUnlockedTutorialStep,
    tutorialTotalSteps: tutorialStore.tutorialTotalSteps,
    status: tutorialStore.status,
    slug: tutorialStore.slug,
    steps: tutorialStore.steps || [],
  } as BaseTutorialStore;
};

export const getConsultantIsTutorialModeActiveSelector = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return tutorialStore?.isTutorialModeActive ?? false;
};

export const getConsultantCurrentlyViewedStep = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return tutorialStore?.currentlyViewedStep ?? 0;
};

export const getConsultantMaxUnlockedTutorialStep = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return tutorialStore?.maxUnlockedTutorialStep ?? 0;
};

export const getConsultantTutorialIsExpired = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return tutorialStore ? tutorialStore.isTutorialExpired : false;
};

export const getConsultantTutorialStatus = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return tutorialStore ? tutorialStore.status : 'LOADING';
};

export const getConsultantTutorialTotalSteps = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return tutorialStore?.steps?.length ?? 1;
};

export const getConsultantTutorialSteps = (state: StateType) => {
  const tutorialStore = state.get('consultantTutorial');
  return (tutorialStore?.steps as ConsultantTutorialStep[]) ?? ([] as ConsultantTutorialStep[]);
};
